import { Alert } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { ModalContentContainer } from './Modal.styles';

const ModalAlertBody = ({
  type,
  unit,
}: {
  type: 'delete' | 'deactivate';
  unit: any;
}) => {
  const { t } = useTranslation();

  return (
    <ModalContentContainer>
      <p data-testid={`${type}-subtitle`}>
        <Trans
          i18nKey={`pageProperty.units.modals.${type}.subtitle`}
          values={{ unitName: unit.name }}
          components={{ 1: <span className="green" /> }}
        />
      </p>
      <Alert bsStyle="danger">
        {t(`pageProperty.units.modals.${type}.alertBody`)}
      </Alert>
    </ModalContentContainer>
  );
};

export default ModalAlertBody;
